import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "450px",
    height: "24px",
    "@media (max-width: 768px)": {
      width: "300px",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    maxHeight: "180px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "180px",
    overflowY: "auto",
    fontSize: "16px",
  }),
  control: (provided) => ({
    ...provided,
    minHeight: "36px",
    height: "36px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    height: "14px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "8px",
    svg: {
      width: "18px",
      height: "18px",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "16px",
    marginBottom: "10px",
    color: "#004999",
    "@media (max-width: 768px)": {
      fontSize: "12px",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "16px",
    marginBottom: "0px",
    color: "#004999",
  }),
  input: (base) => ({
    ...base,
    padding: "0px",
  }),
};

// const banks = [
//   { value: "66d6e36507409502644872", label: "Bank" },
//   { value: "66d6e3794d948034147381", label: "Merchant" },
//   { value: "66d6e36eddd3a195931539", label: "Wallet" },
// ];

const banks = [
  { 
    value: "66d6e36507409502644872", 
    label: { 
      en: "Bank", 
      Hi: "बैंक", 
      Kn: "ಬ್ಯಾಂಕ್" 
    } 
  },
  { 
    value: "66d6e3794d948034147381", 
    label: { 
      en: "Merchant", 
      Hi: "व्यापारी", 
      Kn: "ವ್ಯಾಪಾರಿ" 
    } 
  },
  { 
    value: "66d6e36eddd3a195931539", 
    label: { 
      en: "Wallet", 
      Hi: "वॉलेट", 
      Kn: "ವಾಲೆಟ್" 
    } 
  },
];



// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Fraudster's bank account details.",
    selectTransferFirst: "Select The Money Transfer First",
    moneyTransferLabel: "Money Transfer:",
    selectBankLabel: "Select the Bank:",
    accNumberLabel: "Account No/ Credit/Debit Card No:",
    placeholderTransfer: "Select...",
    placeholderBank: "Select...",
    placeholderAcc: "Enter Account No/ Credit/Debit Card No",
    ok: "OK",
  },
  Hi: {
    header: "धोखेबाज़ के बैंक खाते का विवरण।",
    selectTransferFirst: "पहले मनी ट्रांसफर चुनें",
    moneyTransferLabel: "मनी ट्रांसफर:",
    selectBankLabel: "बैंक चुनें:",
    accNumberLabel: "खाता संख्या/ क्रेडिट/डेबिट कार्ड संख्या:",
    placeholderTransfer: "चुनें...",
    placeholderBank: "चुनें...",
    placeholderAcc: "खाता संख्या दर्ज करें/ क्रेडिट/डेबिट कार्ड संख्या",
    ok: "ठीक है",
  },
  Kn: {
    header: "ವಂಚಕರ ಬ್ಯಾಂಕ್‌ ಖಾತೆಯ ವಿವರಗಳು.",
    selectTransferFirst: "ಹಣ ವರ್ಗಾವಣೆಯ ವಿವರ ಆಯ್ಕೆ ಮಾಡಿ.",
    moneyTransferLabel: "ಹಣ ವರ್ಗಾವಣೆ ವಿಧಾನ:",
    selectBankLabel: "ಬ್ಯಾಂಕ್ ಆಯ್ಕೆಮಾಡಿ:",
    accNumberLabel: "ಖಾತೆ ಸಂಖ್ಯೆ/ಕ್ರೆಡಿಟ್/ಡೆಬಿಟ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ:",
    placeholderTransfer: "ಆಯ್ಕೆಮಾಡಿ...",
    placeholderBank: "ಆಯ್ಕೆಮಾಡಿ...",
    placeholderAcc: "ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ/ಕ್ರೆಡಿಟ್/ಡೆಬಿಟ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
    ok: "ಸರಿ",
  },
};

const SuspectBank = ({
  onNext,
  onSuspectBankSelected,
  addSuspectBank,
  index,
  onQuestion,
  onNextPage,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang
}) => {
  const [SuspectFormData, setSuspectFormData] = useState({
    transferType: "",
    bank: "",
    acc_no: "",
  });
  const [bankOptions, setBankOptions] = useState([]);
  const [merchantOption, setMerchantOptions] = useState([]);
  const [rawBankData, setRawBankData] = useState(null);
  const [rawMerchantData, setRawMerchantData] = useState(null);
  const [rawWalletData, setRawWalletData] = useState(null);
  const [walletOption, setWalletOptions] = useState([]);
  const [error, setError] = useState("");
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const audioRef = useRef(null);
  const [previousSelectedBank, setPreviousSelectedBank] = useState({});

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/suspectbank.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio19.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio19.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };



  // When the selected language changes, update the audio element's source automatically
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Retrieve stored form data from localStorage on mount
  useEffect(() => {
    const storedDistrict = localStorage.getItem("SuspectBank");
    if (storedDistrict) {
      const data = JSON.parse(storedDistrict);
      setSuspectFormData({
        bank: data.bank || "",
        acc_no: data.acc_no || "",
        transferType: data.transferType || "",
      });
      setPreviousSelectedBank({
        bank: data.bank || "",
        acc_no: data.acc_no || "",
        transferType: data.transferType || "",
      });
    }
  }, []);

    const getBankList = (resp, language) => {
      switch (language) {
        case "en":
          return resp.lang_eng;
        case "Hi":
          return resp.lang_hin;
        case "Kn":
          return resp.lang_kanada;
        default:
          return resp.lang_eng; // fallback
      }
    };
  
  
    useEffect(() => {
      if (rawBankData) {
        const ProfessionList = getBankList(rawBankData, selectedLang) || [];
        setBankOptions(
          ProfessionList.map((profession, index) => ({
            id: String.fromCharCode(65 + index),
            value: profession.bwpa_uniq,
            label: profession.bwpa_nm,
          })) || []
        );
      }
    }, [selectedLang, rawBankData]);


    useEffect(() => {
      if (rawMerchantData) {
        const ProfessionList = getBankList(rawMerchantData, selectedLang) || [];
        setMerchantOptions(
          ProfessionList.map((profession, index) => ({
            id: String.fromCharCode(65 + index),
            value: profession.mrchnt_uniq,
            label: profession.mrchnt_nm,
          })) || []
        );
      }
    }, [selectedLang, rawMerchantData]);


    useEffect(() => {
      if (rawWalletData) {
        const ProfessionList = getBankList(rawWalletData, selectedLang) || [];
        setWalletOptions(
          ProfessionList.map((profession, index) => ({
            id: String.fromCharCode(65 + index),
            value: profession.wpa_uniq,
            label: profession.wpa_nm,
          })) || []
        );
      }
    }, [selectedLang, rawWalletData]);

  // Fetch options for Bank, Merchant, and Wallet based on API
  useEffect(() => {
    const fetchBankData = async () => {
      try {
        const BankResponse = await fetch(`${apiUrl}/v1/cy_ma_bank_wlet_pg_pa_list`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f6545af3d6e",
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!BankResponse.ok) {
          throw new Error("Failed to fetch bank options");
        }
        const BankData = await BankResponse.json();

        setRawBankData(BankData.resp);
        // setBankOptions(
        //   BankData?.resp?.bank_wlet_pg_pa_list?.map((bank) => ({
        //     value: bank.bwpa_uniq,
        //     label: bank.bwpa_nm,
        //   })) || []
        // );
      } catch (error) {
        console.error("Error fetching bank data:", error);
      }
    };


    const fetchMerchantData = async () => {
      try {
        const BankResponse = await fetch(`${apiUrl}/v1/cy_ma_merchants_list`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f6545af3d6e",
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!BankResponse.ok) {
          throw new Error("Failed to fetch Merchant options");
        }
        const BankData = await BankResponse.json();
        setRawMerchantData(BankData.resp);
        setMerchantOptions(
          BankData?.resp?.merchants_list?.map((bank) => ({
            value: bank.mrchnt_uniq,
            label: bank.mrchnt_nm,
          })) || []
        );
      } catch (error) {
        console.error("Error fetching Merchant data:", error);
      }
    };

    const fetchWalletData = async () => {
      try {
        const BankResponse = await fetch(`${apiUrl}/v1/cy_ma_wlet_pg_pa_list`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f6545af3d6e",
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!BankResponse.ok) {
          throw new Error("Failed to fetch Wallet options");
        }
        const BankData = await BankResponse.json();
        setRawWalletData(BankData.resp);
        // setWalletOptions(
        //   BankData.resp.wlet_pg_pa_list.map((bank) => ({
        //     value: bank.wpa_uniq,
        //     label: bank.wpa_nm,
        //   })) || []
        // );
      } catch (error) {
        console.error("Error fetching Wallet data:", error);
      }
    };

    fetchBankData();
    fetchMerchantData();
    fetchWalletData();
  }, [apiKey, app_ver, botToken, vist_id]);

  const handleSelectChange = (id, selectedOption) => {
    setSuspectFormData((prev) => ({
      ...prev,
      [id]: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleSelectTypeChange = (id, selectedOption) => {
    setSuspectFormData((prev) => ({
      ...prev,
      [id]: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleTextChange = (id, value) => {
    let updatedFormData;
    if (id === "acc_no") {
      if (/^[a-zA-Z0-9\s]*$/.test(value) && value.length <= 50) {
        updatedFormData = { ...SuspectFormData, [id]: value };
        setSuspectFormData(updatedFormData);
      } else {
        setError("Please enter a valid account number");
      }
    } else if (id === "trans_id") {
      if (/^[a-zA-Z0-9\s]*$/.test(value) && value.length <= 50) {
        updatedFormData = { ...SuspectFormData, [id]: value };
        setSuspectFormData(updatedFormData);
      } else {
        setError("Transaction number can only contain letters, numbers, and spaces.");
      }
    } else if (id === "amt") {
      if (/^\d*\.?\d*$/.test(value)) {
        updatedFormData = { ...SuspectFormData, [id]: value };
        setSuspectFormData(updatedFormData);
        setError("");
      } else {
        setError("Amount can only contain numbers and a decimal point.");
      }
    } else {
      updatedFormData = { ...SuspectFormData, [id]: value };
      setSuspectFormData(updatedFormData);
      setError("");
    }
  };

  const handleOkClick = async (e) => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    if (JSON.stringify(SuspectFormData) !== JSON.stringify(previousSelectedBank)) {
      if (SuspectFormData.transferType && SuspectFormData.acc_no && SuspectFormData.bank) {
        if (SuspectFormData.acc_no.length <= 5) {
          setError("Please Enter the valid account number.");
          return;
        }
        try {
          const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_susp_trans`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f6545af3d6e",
              qtion_num: "16",
              mtfr_uni: SuspectFormData.transferType,
              bwpa_uni: SuspectFormData.bank,
              acc_no: SuspectFormData.acc_no,
              lac_token: botToken,
              app_ver: app_ver,
              bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
            }),
          });
          if (!response.ok) {
            throw new Error("Failed to submit form data.");
          }
          const responseData = await response.json();
          if (responseData.resp.error_code !== "0") {
            setError("Failed to push data to API");
          }
          localStorage.setItem("SuspectBank", JSON.stringify(SuspectFormData));
          setPreviousSelectedBank({
            bank: SuspectFormData.bank || "",
            acc_no: SuspectFormData.acc_no || "",
            transferType: SuspectFormData.transferType || "",
          });
        } catch (error) {
          console.error("Error submitting form data:", error);
          setError("Failed to submit form data. Please try again.");
        }
      }
    }
    onNext(18);
    onQuestion(19);
    setError("");
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question" style={{ marginBottom: "150px" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex" }}>
            <h2 className="suspect-bank">
              {translations[selectedLang].header}
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }} />}
            </button>
            <audio ref={audioRef} onEnded={handleAudioEnd}>
              <source src={audioMap[selectedLang]} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </div>
          <div className="name-list">
            <p className="bank-para">{translations[selectedLang].moneyTransferLabel}</p>
            <Select
              value={banks.find(
                (bank) => bank.value === SuspectFormData.transferType
              )}
              onChange={(selectedOption) =>
                handleSelectTypeChange("transferType", selectedOption)
              }
              options={banks}
              getOptionLabel={(option) =>
                // Check if label is an object, then use selected language or fallback to English
                typeof option.label === "object"
                  ? option.label[selectedLang] || option.label.en
                  : option.label
              }
              className="dropdown-input"
              placeholder={translations[selectedLang].placeholderTransfer}
              styles={customStyles}
            />
            <p className="bank-para" style={{ marginTop: "20px" }}>
              {translations[selectedLang].selectBankLabel}
            </p>
            <Select
              value={
                SuspectFormData.transferType === "66d6e36507409502644872"
                  ? bankOptions.find((Bank) => Bank.value === SuspectFormData.bank) || null
                  : SuspectFormData.transferType === "66d6e3794d948034147381"
                  ? merchantOption.find((Merchant) => Merchant.value === SuspectFormData.bank) || null
                  : SuspectFormData.transferType === "66d6e36eddd3a195931539"
                  ? walletOption.find((Wallet) => Wallet.value === SuspectFormData.bank) || null
                  : null
              }
              onChange={(selectedOption) => {
                if (SuspectFormData.transferType === "66d6e36507409502644872") {
                  handleSelectChange("bank", selectedOption);
                } else if (SuspectFormData.transferType === "66d6e3794d948034147381") {
                  handleSelectChange("bank", selectedOption);
                } else if (SuspectFormData.transferType === "66d6e36eddd3a195931539") {
                  handleSelectChange("bank", selectedOption);
                }
              }}
              options={
                SuspectFormData.transferType === "66d6e36507409502644872"
                  ? bankOptions
                  : SuspectFormData.transferType === "66d6e3794d948034147381"
                  ? merchantOption
                  : SuspectFormData.transferType === "66d6e36eddd3a195931539"
                  ? walletOption
                  : []
              }
              className="dropdown-input"
              placeholder={
                SuspectFormData.transferType === ""
                  ? translations[selectedLang].selectTransferFirst
                  : translations[selectedLang].placeholderBank
              }
              isDisabled={!SuspectFormData.transferType}
              styles={customStyles}
            />
            <p className="bank-para" style={{ marginTop: "20px" }}>
              {translations[selectedLang].accNumberLabel}
            </p>
            <input
              type="text"
              className="text-input account"
              name="acc_no"
              value={SuspectFormData.acc_no}
              onChange={(e) => handleTextChange("acc_no", e.target.value)}
              autoComplete="off"
              placeholder={translations[selectedLang].placeholderAcc}
            />
          </div>
          <div style={{ display: "flex", position: "relative", zIndex: "9" }}>
            <button type="button" className="ok-btn" onClick={handleOkClick}>
              {translations[selectedLang].ok}
            </button>
          </div>
        </div>
        {error && (
          <p className="error-message" style={{ position: "relative", zIndex: "1000" }}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default SuspectBank;
